import NaviTable from '@cp/src/components/NaviTable/NaviTable';
import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';
import { columns } from '../constants/MockAllocationConstants';
import StatusContainer from '../DataContainers/StatusContainer';
import ProcessingDetails from '../DataContainers/ProcessingDetails';
import { PreparationData } from '../../../interface';
import { InputStatus } from '../../../types';
import { SELF_SERVE_UI_CLICKSTREAM } from '@cp/src/service/clickStream.constant';
import FileDownloadButton from '@cp/src/components/Buttons/FileDownloadButton';

interface InputStateProps {
  header: React.ReactNode;
  showMockAllocationDetails?: boolean;
  showTable?: boolean;
  showPreviousAllocationDetails?: boolean;
}

const DownloadButtons = ({ details }: { details: PreparationData }) => {
  const mockId =
    useSelector(
      (state: RootState) => state?.fieldAllocation?.fieldAllocationDetails?.allocationTrackerId
    ) || '';
  if (details?.preparationStatus?.value !== InputStatus.SUCCESS) return null;

  const attribute = {
    mockId: mockId
  };

  return (
    <div className="flex flex-col">
      <FileDownloadButton
        label="Inhouse"
        presignedUrl={details?.presignedUrls?.agentsInputData}
        fileName="Input inhouse file"
        clickstreamEvent={SELF_SERVE_UI_CLICKSTREAM.LH_DOWNLOAD_INHOUSE_FILE_CLICKED}
        attributes={attribute}
      />
      <FileDownloadButton
        label="Agency"
        presignedUrl={details?.presignedUrls?.agenciesInputData}
        fileName="Input agency file"
        clickstreamEvent={SELF_SERVE_UI_CLICKSTREAM.LH_DOWNLOAD_AGENCY_FILE_CLICKED}
        attributes={attribute}
      />
    </div>
  );
};

const InputState = (props: InputStateProps) => {
  const {
    header,
    showMockAllocationDetails = false,
    showTable = false,
    showPreviousAllocationDetails = false
  } = props;

  const previousAllocationInputData = useSelector(
    (state: RootState) => state?.fieldAllocation?.previousAllocationDetails
  );
  const currentAllocationInputData = useSelector(
    (state: RootState) => state?.fieldAllocation?.fieldAllocationDetails
  );

  const preparationDetails = showPreviousAllocationDetails
    ? previousAllocationInputData
    : currentAllocationInputData;

  const inputPreparationDetails = preparationDetails?.inputPreparationData;
  return (
    <StatusContainer
      header={header}
      detailsComponent={
        showMockAllocationDetails ? (
          <div className="flex justify-between">
            <ProcessingDetails showInputProcessingDetails allocationDetails={preparationDetails} />
            <DownloadButtons details={inputPreparationDetails} />
          </div>
        ) : null
      }
      tableComponent={
        showTable && inputPreparationDetails?.validationData ? (
          <div className="mt-4">
            <NaviTable
              data={Object.values(inputPreparationDetails?.validationData || {})}
              columns={columns}
              sizeColumnsToFit={true}
              tableClasses="!h-auto"
            />
          </div>
        ) : null
      }
      experimentsData={inputPreparationDetails?.presignedUrls?.experimentsData}
    />
  );
};

export default InputState;
